import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'aipb-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageComponent implements OnChanges {
  @Input() src: string;
  @Input() height: string;
  @Input() fullWidth = false;
  @Input() border = true;

  valid = true;

  ngOnChanges(): void {
    this.valid = true;
  }

  onError(): void {
    this.valid = false;
  }
}
